export default __webpack_public_path__ + "static/media/79t.72415f17.jpg";